import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm3.22,8.26a.49.49,0,0,1-.19.39L11,11.8a.25.25,0,0,0,0,.4l4,3.15a.49.49,0,0,1,.19.39v2.69a.5.5,0,0,1-.82.39L6.68,12.38a.49.49,0,0,1,0-.76L14.4,5.18a.5.5,0,0,1,.82.39Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }